<template>
    <table class="tenders-table">
        <caption class="tenders-table__title">{{ tableTitle }}</caption>
        <thead>
            <tr class="no-hover">
                <th class="w-1">Год</th>
                <th v-for="(t,i) in theadList" :key="i">{{ t }}</th>
            </tr>
        </thead>
        <tbody v-if="years.length">
            <tr v-for="(y,i) in years" :key="i">
                <td class="w-1 print-grey">{{ y }}</td>
                <td>
                    <button class="table-btn" @click="getFullInfo(y)">{{ stat[y][keys[0][0]] }}</button>
                    <span>на {{ moneyFormat(stat[y][keys[0][1]] / 1000000, 2) }}</span>
                    <span class="measure">млн. <i class="uk-icon-rub"></i></span>
                </td>
                <td>
                    <button class="table-btn" @click="getFullInfo(y)">{{ stat[y][keys[1][0]] }}</button>
                    <span>на {{ moneyFormat(stat[y][keys[1][1]] / 1000000, 2) }}</span>
                    <span class="measure">млн. <i class="uk-icon-rub"></i></span>
                </td>
            </tr>
            <tr class="no-hover no_print">
                <td class="last-cell" colspan="3"><hr /></td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="no-hover">
                <td class="w-1 print-grey">Все годы</td>
                <td>
                    <span>{{ stat.total[keys[0][0]] }}</span>
                    <span>на {{ moneyFormat(stat.total[keys[0][1]] / 1000000, 2) }}</span>
                    <span class="measure">млн. <i class="uk-icon-rub"></i></span>
                </td>
                <td>
                    <span>{{ stat.total[keys[1][0]] }}</span>
                    <span>на {{ moneyFormat(stat.total[keys[1][1]] / 1000000, 2) }}</span>
                    <span class="measure">млн. <i class="uk-icon-rub"></i></span>
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { moneyFormat } from '@/helpers.ts'

export default {
    props: {
        type: {
            type: String,
            required: true,
            default: 'participants'
        },
        years: {
            type: Array,
            required: true,
            default: []
        },
        stat: {
            type: Object,
            required: true,
            default: {}
        }
    },
    computed: {
        tableTitle() { return this.$props.type === 'participants' ? 'Победитель / Участник' : 'Заказчик с контрактом / Заказчик' },
        theadList() {
            if(this.$props.type === 'participants') {
                return ['Участвовал в лотах', 'Выиграл лотов' ]
            } else {
                return ['Лотов с контрактом', 'Лотов без контракта']
            }
        },
        keys() {
            if(this.$props.type === 'participants') {
                return [['lots_total', 'sum_total'], ['lots_win', 'sum_win']]
            } else {
                return [['lots_with_contr', 'sum_with_contr'], ['lots_not_contr', 'sum_not_contr' ]] 
            }
        },
        ogrn() { return this.$store.state.card?.company?.ogrn }
    },
    methods: {
        getFullInfo(year) {
            this.$store.dispatch('card/tenders/getFullInfo', { 
                ogrn: Number(this.ogrn), 
                type: this.$props.type, 
                year, 
                limit: 50, 
                offset: 0 
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.tenders-table
    @include lic-table
    tr.no-hover
        &:hover
            background: none
    .table-btn
        background: none
        border: none
        @include pseudo-link
    tr td, tr th
        text-align: right
    tr
        td
            padding-top: 10px
            padding-bottom: 0
        td.last-cell
            padding-top: 0
            hr
                margin: 0
    .w-1
        width: 1%
        text-align: center
        font-weight: 600 
    .measure
        white-space: nowrap
        font-size: 11px
        font-style: italic
        color: #8f8f8f
        vertical-align: bottom
    &__title
        text-align: center
        text-decoration: underline
        font-size: 15px
        font-weight: 600
        line-height: 18px
        color: #444
        margin-bottom: 15px
    tfoot
        color: #575757
        font-weight: 600
        font-size: 12px
        font-style: italic
</style>